interface Input {
  position: 'center' | 'top' | 'bottom' | 'left' | 'right' | 'center left' | 'center right' | 'top left' | 'top right' | 'bottom left' | 'bottom right'
  radialSize: string
  color1: string
  color2: string
}

const doubleInput: Input[] = [
  { position: 'top', radialSize: '35.56% 50%', color1: 'rgba(71, 235, 235, 0.18)', color2: 'rgba(71, 235, 235, 0)' },
  { position: 'bottom', radialSize: '35.56% 50%', color1: 'rgba(38, 217, 127, 0.12)', color2: 'rgba(38, 217, 127, 0)' }
]

const singleInput: Input[] = [{ position: 'center', radialSize: '35.56% 50%', color1: 'rgba(71, 235, 235, 0.18)', color2: 'rgba(71, 235, 235, 0)' }]

export function generateRadialGradient(
  inputs: Input[] = doubleInput,
  bgColor: string | boolean = 'rgb(29, 30, 48)',
  bgImageUrl: string | boolean = '/assets/images/bg-noise.webp'
) {
  const finalArray = []

  // radial-gradient inputs
  const inputStrings = []
  for (const input of inputs) {
    const { position, color1, color2, radialSize } = input
    inputStrings.push(`radial-gradient(${radialSize} at ${position}, ${color1} 0%, ${color2} 100%)`)
  }

  const stringifiedInputs = inputStrings.join(', ')

  if (stringifiedInputs) {
    finalArray.push(stringifiedInputs)
  }
  // bgImageUrl
  const stringifiedBgImageUrl = typeof bgImageUrl === 'string' ? `url("${bgImageUrl}")` : undefined

  if (stringifiedBgImageUrl) {
    finalArray.push(stringifiedBgImageUrl)
  }

  // background color
  // const bgColor = 'rgb(29, 30, 48)'

  if (typeof bgColor === 'string') {
    finalArray.push(bgColor)
  }

  const finalCssString = finalArray.join(', ')

  return finalCssString

  // const css = `${stringifiedUrl},
  //       ${stringifiedInputs},
  //       ${bgColor}`
  //
  // return css
}
